import { Route, Switch as SwitchRouter } from "react-router-dom";
import { AsyncRoute } from "./AsyncRoute";
import { DocumentEditors } from "@/app/providers/services";
import { AppSidebar, useAppSidebar } from "../common/Sidebar/AppSidebar";
import { FEATURE_SETTINGS_CHANGED_EVENT, isFeatureEnabled, isFeatureOrParentEnabled } from "@/config/features";
import DecisivelyLayoutNonCompact from "./DecisivelyLayoutNonCompact";
import { Header } from "@/ui/blocks/Header";
import React from "react";
import { AdapterWorkflowPanel, isAdapterWorkflowPath } from "@/features/adapters";

export interface DecisilveyLayoutProps {
  page?: React.ReactNode;
  routes?: any[];
  childRoutes?: any[];
  location?: any;
  match?: any;
}


const DecisivelyLayout = (props: DecisilveyLayoutProps) => {
  // Check if compact design is enabled
  const isCompactEnabled = isFeatureEnabled('design.compact');
  const isDebugGrid = isFeatureEnabled('developer.debug');

  // If compact is disabled, use the non-compact layout
  if (!isCompactEnabled) {
    return <DecisivelyLayoutNonCompact {...props} />;
  }

  // Compact layout (current design)
  // pulling routes as we dont want it in props as we unpack into sidebar
  const { page, routes, childRoutes, location, match } = props;
  const [, refreshFeatureSettings] = React.useReducer((value) => value + 1, 0);
  React.useEffect(() => {
    window.addEventListener(FEATURE_SETTINGS_CHANGED_EVENT, refreshFeatureSettings);
    return () => window.removeEventListener(FEATURE_SETTINGS_CHANGED_EVENT, refreshFeatureSettings);
  }, []);
  const visibleChildRoutes = (childRoutes ?? []).filter((route) => !route.feature || isFeatureOrParentEnabled(route.feature));
  const showAdapterWorkflow = isAdapterWorkflowPath(location?.pathname ?? "");

  return (
    <AppSidebar className="h-full" routes={visibleChildRoutes} location={location} match={match}>
      {/* defined here as its not really required app wide */}
      <DocumentEditors />

      {/* Header and content on the right */}
      <div className="flex flex-col flex-1 h-full w-full overflow-hidden">
        {isDebugGrid && <div className="debug-grid-layer" />}
        <AppHeader routes={visibleChildRoutes} />
        <div data-header className="flex-1 flex flex-col w-full p-2 pt-0 pl-0 overflow-hidden bg-sidebar">
          <div className="relative flex min-h-0 flex-1 rounded-2xl border bg-background overflow-hidden">
            <div className="flex min-w-0 flex-1 flex-col">
              <AsyncRoute>
                {childRoutes ? (
                  <SwitchRouter>
                    {visibleChildRoutes.map(route => (
                      <Route key={route.path} {...route} />
                    ))}
                  </SwitchRouter>
                ) : (
                  page
                )}
              </AsyncRoute>
            </div>
            {showAdapterWorkflow && <AdapterWorkflowPanel />}
          </div>
        </div>
      </div>
    </AppSidebar>
  );
};

const AppHeader = ({ routes }: { routes: any[] }) => {
  const { toggleSidebar } = useAppSidebar();
  return <Header routes={routes} onToggleSidebar={toggleSidebar} />;
};

export default DecisivelyLayout;
